module.exports = __webpack_public_path__ + "static/drow_mage-9cca2055d14f7aa455c651e41757c91b.jpeg";